/* Common Imports */

import React from "react";
import PropertyCard from "./PropertyCardBroadcastPreview/PropertyCardBroadcastPreview";

/* Component Imports */

import { NextRouter } from "next/router";
import PropertyLoadingCardDashboardEditorView from "../skeletonLoadingCard/PropertyLoadingCardDashboardEditorView";

/* Styled Components */

const PropertyCardBroadcastPreview = ({
	PropertyId,
	dispatch,
	router,
	source,
	broadcast_commission,
	broadcast_notes,
}: {
	PropertyId: any;
	dispatch: any;
	router: NextRouter;
	source?: string;
	broadcast_commission: number;
	broadcast_notes: string;
}) => {
	const [propertyData, setPropertyData] = React.useState<any>({});

	const [propertyDataloading, setPropertyDataLoading] = React.useState(true);

	React.useEffect(() => {
		if (PropertyId) {
			/* Fetching property data */

			fetch(`${process.env.PRODUCTION_API_URL}properties/cards/${PropertyId}?resize=""`, {
				method: "POST",
				headers: {
					"Content-Type": "text/plain",
				},
			})
				.then((res) => res.json())
				.then((data) => {
					setPropertyData(data.property_data);
					setPropertyDataLoading(false);
				});
		}

		/* eslint-disable-next-line react-hooks/exhaustive-deps*/
	}, [PropertyId]);

	if (propertyDataloading) {
		return (
			<PropertyLoadingCardDashboardEditorView
				source={source}
				isEditor={false}
				show_only_listing_details={true}
			/>
		);
	}

	return (
		<React.Fragment>
			<PropertyCard
				_id={propertyData._id}
				dispatch={dispatch}
				router={router}
				loading={propertyDataloading}
				transaction_type={propertyData.transaction_type ? propertyData.transaction_type : ""}
				property_type={propertyData.property_type}
				title={propertyData.title}
				images={propertyData.images}
				location={propertyData.location ? propertyData.location.title : ""}
				price={propertyData.price}
				bhk={propertyData.bhk}
				area={propertyData.area}
				no_of_seats={propertyData.no_of_seats}
				source={source}
				broadcast_commission={broadcast_commission}
				broadcast_notes={broadcast_notes}
			/>
		</React.Fragment>
	);
};

export default PropertyCardBroadcastPreview;
